import React, { Component } from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { renderSelectField, renderCheckbox, renderTextField } from '../../utils/materialUiReduxForms';
import CircularProgress from 'material-ui/CircularProgress';
import MenuItem from 'material-ui/MenuItem'
import { literals } from './../../languages';
import { getUserRoles } from '../../utils/helpers';

class Form extends Component {

  componentWillMount () {
    let token = localStorage.getItem('betwidgets_login_token');
    if (token) {
      let roles = getUserRoles(token);
      this.setState({
        'isAdmin': roles.indexOf('ROLE_ADMIN') !== -1  ? true : false
      });
    }
  }

  renderField(data) {
    const hasError = data.meta.touched && !!data.meta.error;
    if (hasError) {
      data.input['aria-describedby'] = `client_${data.input.name}_helpBlock`;
      data.input['aria-invalid'] = true;
    }

    return <div className={`form-group${hasError ? ' has-error' : ''}`}>
      <label htmlFor={`client_${data.input.name}`} className="control-label">{data.input.name}</label>
      <input {...data.input} type={data.type} step={data.step} required={data.required} placeholder={data.placeholder} id={`client_${data.input.name}`} className="form-control"/>
      {hasError && <span className="help-block" id={`client_${data.input.name}_helpBlock`}>{data.meta.error}</span>}
    </div>;
  }

  renderLanguagesItems(languages = []) {
    return languages && languages.map(l => 
      <MenuItem value={l['@id']} primaryText={l.name} key={`language-${l.id}`} />
    )
  }

  //using products for the label * Couldnt get field.name
  renderProducts = ({fields, products}) => {

    //DEDOULIS REMOVE TZIROI APP + WIDGET 
    if (!this.state.isAdmin && products){ 
      products = products.slice().filter( p => {
        return ['/api/products/1', '/api/products/2'].indexOf(p['@id']) === -1;
      });
    }
    return products
      ? fields.map( (field, i) => 
          <Field key={i} name={`${field}.name`} value='off' checked={false} isChecked={false} defaultChecked={false} component={renderCheckbox} label={`${products[i].name}`} type="checkbox"> 
          </Field>
        )

      : <CircularProgress style={{color:'teal'}} size={40} thickness={6} />
  }


  render() {
    const { handleSubmit } = this.props;

    return <form onSubmit={handleSubmit} className="client-submit-form">
      <Field label="Name" component={renderTextField} name="name" type="text" placeholder="" />
      <div className="client-form-hint">{literals.clientDomainHint[this.props.locale]}</div>
      <Field component={renderTextField} name="domainName" type="text" placeholder="" />
      <div className="checkboxes-container">
        <Field label="is HTTPS" component={renderCheckbox} name="isHttps" type="checkbox" placeholder="" />
        {
          this.state.isAdmin 
            ? <Field label="is Enabled" component={renderCheckbox} name="isEnabled" type="checkbox" placeholder="" />
            : ''
        }
         {
          this.state.isAdmin 
            ? <Field label="Has Wbs Feed" component={renderCheckbox} name="hasWbsFeed" type="checkbox" placeholder="" />
            : ''
        }
      </div>
      <Field component={renderSelectField} name="language" type="dropdown" placeholder="" label="Language">
        { this.renderLanguagesItems(this.props.languages) }
      </Field>
      <div className="checkboxes-container">
        <FieldArray name='clientProducts' component={this.renderProducts} products={this.props.products}/>
      </div>
        <button type="submit" className="btn btn-primary submit-btn">{literals.submit[this.props.locale]}</button>
    </form>;
  }
}

export default reduxForm({form: 'client', enableReinitialize: true, keepDirtyOnReinitialize: true})(Form);



// WEBPACK FOOTER //
// ./src/components/client/Form.js